import axios from "axios";

const state = () => ({
  person: [],
});

const getters = {
  person(state) {
    return state.person;
  },
};
const mutations = {
  initPerson(state, payload) {
    state.person = payload;
  },
  setPerson(state, data) {
    state.person = data;
  },
  removeItem(state, id) {
    state.person = state.person.filter((x) => x.id != id);
  },
  updateItem(state, payload) {
    state.person = state.person.map((x) => {
      if (x.id == payload.id) return payload;
      else return x;
    });
  },
};
const actions = {
  getPerson({ commit }) {
    axios.get("https://api.uzgeouniver.uz/api/")
      .then(response => {
        commit("initPerson", response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  addPerson({ commit }, data) {
    axios.post("https://api.uzgeouniver.uz/api/", data)
      .then(response => {
        commit("setPerson", response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  deletePerson({ commit }, id) {
    axios.delete(`https://api.uzgeouniver.uz/api/${id}`)
      .then(response => {
        commit("removeItem", id)
      })
      .catch(error => {
        console.log(error);
      })
  },
  replyAppeal({ commit }, payload) {
    axios.patch(`https://api.uzgeouniver.uz/api/${payload.id}`, payload.data)
      .then(response => {
        // console.log(response.data)
        commit("updateItem", payload.data)
      })
      .catch(error => {
        console.log(error);
      })


  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

